import AxiosConfig from "src/Service/Config/AxiosConfig";
import axios from "axios";
import { AuthToken } from "src/Service/Config/AuthToken";
import { localJwtKey } from "src/Service/Config/ApiUrl";

const getCookie = (cname) => {
    var name = cname + "=";
    var decocdeCookie = decodeURIComponent(document.cookie);
    var ca = decocdeCookie.split(';');
    for (var i = 0; i < ca.length; +i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export const AxiosPostJson = async (path, data = {}) => {
    const response = await AxiosConfig.post(path, data, {
        headers: {
            "X-INNO-TOKEN": getCookie("X-INNO-TOKEN")
        }
    });
    return response;
};

export const AxiosGetJson = async (path, data = {}) => {
  const config = {} as any;
  if (data) config.params = data;
  const response = await AxiosConfig.get(path, config);
  return response.data;
};

export const AxiosFiles = async (path, sFileName, data) => {
    // const token = AuthToken.get();
    const token =
      localStorage.getItem(localJwtKey) != null
        ? JSON.parse(localStorage.getItem(localJwtKey) || "")
        : undefined;
    await axios({
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : "",
            "X-INNO-TOKEN": getCookie("X-INNO-TOKEN")
        },
        //url: process.env.REACT_APP_API_URL + "/" + path,
        url: process.env.REACT_APP_API_URL + path,
        method: "POST",
        data: data || {},
        responseType: "blob",
    })
        .then((response) => {
            var blob = new Blob([response.data], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let fileName = sFileName || "";
            if (window.navigator.msSaveOrOpenBlob as any) {
                navigator.msSaveBlob(blob, fileName);
            } else {
                const link = document.createElement("a");
                link.target = "_blank";
                var objectUrl = URL.createObjectURL(blob);
                link.href = objectUrl;
                link.setAttribute("download", fileName);
                link.setAttribute("visibility", "hidden");
                link.click();
                link.remove();
            }
        })
        .catch((error) => console.log("error"));

}

export const AxiosBlobJson = async (path, data = {}) => {
  const response = await AxiosConfig.post(path, data, { responseType: "blob" });
  return response;
}
